import { inject, Injectable } from '@angular/core';
import { IJwtIdTokenClaims } from '@shs-digi-care-monorepo/interfaces';
import { LoginResponse, OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, filter, map, Observable, of, shareReplay, Subject, switchMap, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private securityService = inject(OidcSecurityService);

    public isAuthenticated$: Observable<boolean>;
    private _authUser: Subject<IJwtIdTokenClaims | undefined> = new Subject<IJwtIdTokenClaims | undefined>();
    public authUser$: Observable<IJwtIdTokenClaims | undefined> = this._authUser.pipe(filter((user) => Boolean(user)));
    constructor() {
        this.isAuthenticated$ = this.securityService.checkAuth().pipe(
            tap((auth: LoginResponse) => {
                this._authUser.next(auth.userData as IJwtIdTokenClaims | undefined);
            }),
            map((auth) => auth.isAuthenticated),
            shareReplay({ bufferSize: 1, refCount: true })
        );
    }

    public get accessToken$(): Observable<string> {
        return this.securityService.getAccessToken();
    }

    public login(): void {
        this.securityService.authorize();
    }

    public logout(): void {
        this._authUser.next(undefined);
        this.securityService
            .isAuthenticated()
            .pipe(
                filter((isAuthenticated) => isAuthenticated),
                switchMap(() => this.securityService.logoffAndRevokeTokens()),
                catchError((err) => of(console.error(err)))
            )
            .subscribe();
    }
}
